module.exports = __webpack_public_path__ + "static/img/qsfn2.6fcad38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qsfn2.png
// module id = RUt6
// module chunks = 0